export default __webpack_public_path__ + "static/media/c002-1.00a83aa5.svg";